module.exports = __webpack_public_path__ + "media/images/eye-slash_icon-639c7afe004a5312efd0facdef92a57e.svg";